


































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Watch } from "vue-property-decorator";
import BaseVue from "@/core/BaseVue";
import DatePickerComponent from "@/components/base-datePicker/base-date-picker.vue";
import { Quill } from "vue-quill-editor";
import { ImageDrop } from "quill-image-drop-module";
import AnnoucementService from "@/services/Annoument.service";
import Annoucement from "@/models/annoucement/annoucement.Model";
import AnnoucementPublish from "@/models/annoucement/annoucementPublish.Model";
import GenericAdd from "@/core/Generics/GenericAdd";
import Porposal from "@/models/porposal/porposal.model";
import { PorposalModality } from "@/enums/PorposalModality";
import CoinService from "@/services/coins.service";
import { PorposalExpectedResult } from "@/enums/PorposalExpectedResult";
import ProposalMember from "@/models/porposal/porposalMembers.model";
import ProposalDocument from "@/models/porposal/proposalDocument.Model";
import MemberTypeService from "@/services/memberType.service";
import ProjectTypeService from "@/services/projectType.service";
import DocumentComponent from "@/components/PublishAnnoucement/document.vue";
import GenericEdit from "@/core/Generics/GenericEdit";
import Document from "@/models/document.model";
import BaseHttpClient from "@/core/HttpResources/BaseHttpClient";
import moment from "moment";
import ProposedConsortium from "@/models/porposal/proposedConsortium.Model";
import PorposalBudgetItem from "@/models/porposal/porposalBudgetItem.model";
import { BudgetItemCalculation } from "@/enums/BudgetItemCalculation";
import BudgetItem from "@/models/porposal/budgetItem.model";
import { Utils } from "@/core/Utils";
import BudgetExpenseService from "@/services/budgetExpense.service";
import PorposalBudgetSubItem from "@/models/porposal/porposalBudgetSubItem.model";
import { YearPeriod } from "@/enums/YearPeriod";
import BudgetSubItem from "@/models/porposal/budgetSubItem.model";
import Membertype from "@/models/porposal/memberType.Model";
import PorposalBudgetSubItemInstitutionDetail from "@/models/porposal/porposalBudgetSubItemInstitutionDetail.model";
import UserService from "@/services/user.service";
import BaseModel from "@/models/base/BaseModel.model";
import BaseSelectPerson from "@/components/base/baseSelectPerson/baseSelectPerson.vue";
import BaseSelectResearchCenter from "@/components/base/baseSelectResearchCenter/baseSelectResearchCenter.vue";
import { bus } from "@/main";
import fileService from "@/services/file.service";

import UserBasicInformationComponent from "@/components/user-basic-information/userBasicInformation.vue";
import { ProposalState } from "@/enums/ProposalState";
import User from "@/models/security/user.model";
import PorposalService from "@/services/porposalMember.service";
import PorposalMemberService from "@/services/porposalMember.service";
import PorposalMemberEffort from "@/models/porposal/porposalMemberEffort.model";
import { ProjectState } from "@/enums/projectState";
import ProposalScheduleGanttActivity from '@/models/porposal/ProposalScheduleGanttActivity.model';
import ProposalScheduleGanttPhase from '@/models/porposal/proposalScheduleGanttPhase.model';
import GantCharttComponent from "@/components/ganttChart/gantChartt.vue";
import ProjectType from '@/models/porposal/sendedPorposal.Model';
import PorposalProjectType from '@/models/porposal/porposalProjectType.model';

@Component({
  components: {
    DatePickerComponent,
    documentcomponent: DocumentComponent,
    BaseSelectPerson,
    UserBasicInformationComponent,
    BaseSelectResearchCenter,
    GantCharttComponent
  }
})
export default class PorposalEdit extends GenericEdit<Porposal> {
  currentTab = 1;
  memberTypes: Array<Membertype> = [];
  projectTypes: any = [];
  messageError = "";
  annoucementService = new AnnoucementService();
  annoucementId: number = 0;
  annoucement: AnnoucementPublish = new AnnoucementPublish();
  PorposalModality = PorposalModality;
  PorposalExpectedResult = PorposalExpectedResult;
  CoinService = new CoinService();
  memberTypeService: MemberTypeService = new MemberTypeService();
  projectTypeService: ProjectTypeService = new ProjectTypeService();
  porposalMemberService: PorposalMemberService = new PorposalMemberService();
  isEqualQuantity: Boolean;
  userService: UserService = new UserService();
  counter: number;
  words: any;
  loading = false;
  dropFiles = [];
  files = [];
  Coins: [];
  currentuserObj = {};
  userObj = {
    userId: 0,
    memberTypeId: 0,
    fullName: "",
    name: ""
  };
  researchCenters = [];
  years: Array<number> = [];
  budgetExpenses = [];
  institutionsForMemberEfforts = [];
  budgetItemCurrent = new PorposalBudgetItem();
  showAddPartida = false;
  budgetExpenseService = new BudgetExpenseService();
  BudgetItemCalculation = BudgetItemCalculation;
  estadoEnviada: ProposalState = ProposalState.EnviadoCI;
  estadoRechazada: ProposalState = ProposalState.RechazadoCI;
  estadoAprobada: ProposalState = ProposalState.AprobadoCI;
  estadoDevuelta: ProposalState = ProposalState.DevueltoCI;
  showModal = false;
  contentTypeId = null;
  showAddSubPartida = false;
  budgetSubItemCurrent = new PorposalBudgetSubItem();
  selected = {};
  sending = false;
  showUserWithoutCodes = false;
  totalBudgetFondocyt: number = 0;
  totalBudgetInstitutionalAport: number = 0;
  totalBudget: number = 0;
  showWarning = false;
  showBudgetResume = false;
  projecTypesSelects = [];
  // ganttDiagramTable
  phaseActivities: Array<ProposalScheduleGanttActivity> = [];
  proposalScheduleGantt = new ProposalScheduleGanttPhase();
  proposalScheduleGanttActivity = new ProposalScheduleGanttActivity();
  defaultOpenedDetails: any = [];
  isEditingPhase: boolean = false;
  showDetailIcon: boolean = true;
  showModalSchedulePhase: boolean = false;
  dependencies: [] = [];
  showModalSchedule = false;
  mozillaWidth: string = ''

  types = [
    {
      id: ProjectState.InProgress,
      name: "En ejecución"
    },
    {
      id: ProjectState.InHold,
      name: "Es espera"
    },
    {
      id: ProjectState.cancelled,
      name: "Cancelado"
    },
    {
      id: ProjectState.Finished,
      name: "Finalizado"
    }
  ];

  constructor() {
    super();
    this.controller = "Porposal";
    this.include = "";
    this.model = new Porposal();
    this.Coins = [];
    this.counter = 0;
    this.words = "";
  }

  addProjectTypes(projectType: ProjectType) {
    let item = new PorposalProjectType();
    if (
      this.model.porposalProjectTypes.some(
        (x: PorposalProjectType) => x.projectTypeId == projectType.id
      )
    ) {

      let Obj = this.model.porposalProjectTypes.find(
        (x: PorposalProjectType) => x.projectTypeId == projectType.id
      );
      let index = this.model.porposalProjectTypes.findIndex(
        (x: PorposalProjectType) => x.projectTypeId == projectType.id
      );
   
      if (Obj.id) {
        Obj.deleted = !Obj.deleted
      } else {
        let index = this.model.porposalProjectTypes.findIndex(
          (x: PorposalProjectType) => x.projectTypeId == projectType.id
        );
        this.model.porposalProjectTypes.splice(index, 1);
      }
    } else {
      item.projectTypeId = projectType.id;
      item.name = projectType.name;
      this.model.porposalProjectTypes.push(item);
    }
  }

  setActivityModal(phase: ProposalScheduleGanttPhase) {
    this.phaseActivities = phase.proposalScheduleGanttActivities.filter(
      (x) => !x.deleted
    );
    this.proposalScheduleGanttActivity.phaseStartDateUI = phase.startDate;
    this.proposalScheduleGanttActivity.phaseEndDateUI = phase.endDate;
    this.proposalScheduleGanttActivity.phaseId = phase.taskId;
    this.showModalSchedule = true;
  }

  setEditPhaseModal(phase: ProposalScheduleGanttPhase) {
    this.proposalScheduleGantt.taskId = phase.taskId;
    this.proposalScheduleGantt.order = phase.order;
    this.proposalScheduleGantt.taskName = phase.taskName;
    this.proposalScheduleGantt.startDate = phase.startDate;
    this.proposalScheduleGantt.endDate = phase.endDate;
    this.isEditingPhase = true;
    this.showModalSchedulePhase = true;
  }

  @Watch("showModalSchedulePhase")
  onShowModalSchedulePhaseChange(value: boolean) {
    if (!value) this.cleanSchedulePhase();
  }

  @Watch("showModalSchedule")
  onShowModalScheduleActivityChange(value: boolean) {
    if (!value) this.cleanScheduleActivity();
  }

  removeTask(phaseId, taskId) {
    let phase = this.model.proposalScheduleGanttPhases.find(
      (x) => x.taskId == phaseId
    );
    if (
      phase.proposalScheduleGanttActivities.some(
        (x) => !x.deleted && x.dependencies.includes(taskId)
      )
    ) {
      this.operationNoAllowed(
        "Hay otras actividades que dependen de la que desea eliminar."
      );
    } else {
      if (
        phase.proposalScheduleGanttActivities.find((x) => x.taskId === taskId)
          .id > 0
      ) {
        let task = phase.proposalScheduleGanttActivities.find(
          (x) => x.taskId === taskId
        );
        task.deleted = true;
      } else {
        phase.proposalScheduleGanttActivities = phase.proposalScheduleGanttActivities.filter(
          (x) => x.taskId !== taskId
        );
      }
    }
  }

  removePhase(phaseId) {
    this.$buefy.dialog.confirm({
      title: "Advertencia",
      type: "is-warning",
      size: "is-medium",
      hasIcon: true,
      confirmText: "Sí",
      cancelText: "No",
      message: "¿Está seguro de querer eliminar esta Fase?",
      onConfirm: () => {
        if (
          this.model.proposalScheduleGanttPhases.find(
            (x) => x.taskId === phaseId
          ).id > 0
        ) {
          let phase = this.model.proposalScheduleGanttPhases.find(
            (x) => x.taskId === phaseId
          );
          phase.deleted = true;
        } else {
          this.model.proposalScheduleGanttPhases = this.model.proposalScheduleGanttPhases.filter(
            (x) => x.taskId !== phaseId
          );
        }
      },
    });
  }

  editPhase(obj: ProposalScheduleGanttPhase) {
    let editedPhase = this.model.proposalScheduleGanttPhases.find(
      (x) => x.taskId == this.proposalScheduleGantt.taskId
    );
    if (obj && obj.endDate > obj.startDate) {
      editedPhase.order = this.proposalScheduleGantt.order;
      editedPhase.taskName = this.proposalScheduleGantt.taskName;
      editedPhase.startDate = this.proposalScheduleGantt.startDate;
      editedPhase.endDate = this.proposalScheduleGantt.endDate;
      this.showModalSchedulePhase = false;
      this.isEditingPhase = false;
      this.cleanSchedulePhase();
    } else {
      this.operationNoAllowed(
        `La fecha final no puede ser menor o igual a la inicial`
      );
    }
  }

  addPhase(obj: ProposalScheduleGanttPhase) {
    if (obj && obj.endDate > obj.startDate) {
      this.model.proposalScheduleGanttPhases.push(
        this.getProposalScheduleGanttPhase()
      );
      this.showModalSchedulePhase = false;
      this.cleanSchedulePhase();
    } else {
      this.operationNoAllowed(
        `La fecha final no puede ser menor o igual a la inicial`
      );
    }
  }

  getProposalScheduleGanttPhase() {
    let proposalScheduleGantt = new ProposalScheduleGanttPhase();
    proposalScheduleGantt.taskId = Utils.newGUID();
    proposalScheduleGantt.order = this.proposalScheduleGantt.order;
    proposalScheduleGantt.taskName = this.proposalScheduleGantt.taskName;
    proposalScheduleGantt.resource = this.proposalScheduleGantt.resource;
    proposalScheduleGantt.startDate = this.proposalScheduleGantt.startDate;
    proposalScheduleGantt.endDate = this.proposalScheduleGantt.endDate;
    return proposalScheduleGantt;
  }

  cleanSchedulePhase() {
    this.isEditingPhase = false;
    this.proposalScheduleGantt.init();
    this.dependencies = [];
  }

  cleanScheduleActivity() {
    this.showModalSchedule = false;
    this.proposalScheduleGanttActivity.init();
    this.dependencies = [];
    this.phaseActivities = [];
  }

  addTask(obj: ProposalScheduleGanttActivity) {
    
    if (obj && obj.endDate > obj.startDate) {
      let dependenciasRequeridas = [];
      this.dependencies.forEach((dependency: ProposalScheduleGanttActivity) => {
        if (dependency.endDate >= obj.startDate)
          dependenciasRequeridas.push(dependency.taskName);
      });
      if (dependenciasRequeridas.length > 0) {
        dependenciasRequeridas.forEach((dependencia) => {
          this.operationNoAllowed(
            `La actividad: ${this.proposalScheduleGanttActivity.taskName} no puede iniciar antes de finalizar la actividad: ${dependencia}`
          );
        });
        return;
      }

      let phase = this.model.proposalScheduleGanttPhases.find(
        (x) => x.taskId == this.proposalScheduleGanttActivity.phaseId
      );
      phase.proposalScheduleGanttActivities.push(
        this.getProposalScheduleGanttActivity()
      );
      this.cleanScheduleActivity();
    } else {
      this.operationNoAllowed(
        "La fecha final no puede ser menor o igual a la inicial"
      );
    }
  }

  getProposalScheduleGanttActivity() {
    let proposalScheduleGantt = new ProposalScheduleGanttActivity();
    proposalScheduleGantt.taskId = Utils.newGUID();
    proposalScheduleGantt.order = this.proposalScheduleGanttActivity.order;
    proposalScheduleGantt.taskName = this.proposalScheduleGanttActivity.taskName;
    proposalScheduleGantt.resource = this.proposalScheduleGanttActivity.resource;
    proposalScheduleGantt.dependencies = this.dependencies
      .map((x: ProposalScheduleGanttActivity) => x.taskId)
      .join(",");
    proposalScheduleGantt.dependenciesUI = this.dependencies.map(
      (x: ProposalScheduleGanttActivity) => x.taskName
    );
    proposalScheduleGantt.startDate = this.proposalScheduleGanttActivity.startDate;
    proposalScheduleGantt.endDate = this.proposalScheduleGanttActivity.endDate;
    return proposalScheduleGantt;
  }

  // ganttDiagramTable

  get isLoading() {
    return this.$store.state.loading;
  }
  getImage(image: any) {
    if (image) return `data:image/jpg;base64, ${image}`;
  }

  next() {
    this.currentTab++;
  }
  back() {
    this.currentTab--;
  }

  getResearchCenter(value: BaseModel) {
    this.institutionsForMemberEfforts.push(value);
  }

  onDropFilesChanges() {
    if (this.dropFiles) {
      this.dropFiles.forEach(currentDoc => {
        this.files.push(currentDoc);
      });
      this.dropFiles = null;
    }
    this.validate();
  }
  verDocumento(row: ProposalDocument) {
    return fileService.download(row.documentId);
  }
  removeDocument(row: ProposalDocument) {
    if (row.id) {
      this.model.proposalDocuments.forEach((currentDocs: any) => {
        if (currentDocs.id === row.id) {
          currentDocs.deleted = true;
          let index = this.files.findIndex((x: any) => x.id == row.id);
          this.files.splice(index, 1);
        }
      });
    } else {
      this.files = this.files.filter((x: any) => x != row);
    }
  }

  @Watch("model.proposalDocuments")
  onProposalDocument() {
    this.files = this.model.proposalDocuments.filter(x => x.document !== null);
    this.selected = this.files[1];
  }

  public getcenterByInvestigatorId() {
    this.userService.researchCenterByInvestigator(this.user.id).then(center => {
      this.researchCenters = center;
    });
  }

  getAnnoucementDetail() {
    this.model.annoucementId = this.annoucementId;
    this.loading = true;
    this.annoucementService
      .getDetailAnnocement(this.annoucementId)
      .then(response => {
        this.annoucement = response;
        this.loading = false;
      });
  }
  protected async getData() {
    try {
      this.controller = "Porposal";
      this.loading = true;
      let response = await this.repository.byId(this.id, this.include);
      console.log(response)
      if (
        response &&
        (response.estado == this.estadoEnviada ||
          response.estado == this.estadoRechazada ||
          response.estado == this.estadoAprobada)
      ) {
        
        this.$router.push(`/convocatoria/propuesta/` + response.id + `/detail`);
      }

      if (response.startDate) response.startDate = new Date(response.startDate);
      if (response.endDate) response.endDate = new Date(response.endDate);

      response.porposalProjectTypes.forEach((item: PorposalProjectType) => {
        this.projecTypesSelects.push(item.projectTypeId);
      });

      if (response.proposalScheduleGanttPhases) {
        for (let i = 0; i < response.proposalScheduleGanttPhases.length; i++) {
          response.proposalScheduleGanttPhases[i].startDate =
            typeof response.proposalScheduleGanttPhases[i].startDate ===
            "string"
              ? new Date(response.proposalScheduleGanttPhases[i].startDate)
              : response.proposalScheduleGanttPhases[i].startDate;
          response.proposalScheduleGanttPhases[i].endDate =
            typeof response.proposalScheduleGanttPhases[i].endDate === "string"
              ? new Date(response.proposalScheduleGanttPhases[i].endDate)
              : response.proposalScheduleGanttPhases[i].endDate;
          for (
            let j = 0;
            j <
            response.proposalScheduleGanttPhases[i]
              .proposalScheduleGanttActivities.length;
            j++
          ) {
            response.proposalScheduleGanttPhases[
              i
            ].proposalScheduleGanttActivities[j].startDate =
              typeof response.proposalScheduleGanttPhases[i]
                .proposalScheduleGanttActivities[j].startDate === "string"
                ? new Date(
                    response.proposalScheduleGanttPhases[
                      i
                    ].proposalScheduleGanttActivities[j].startDate
                  )
                : response.proposalScheduleGanttPhases[i]
                    .proposalScheduleGanttActivities[j].startDate;
            response.proposalScheduleGanttPhases[
              i
            ].proposalScheduleGanttActivities[j].endDate =
              typeof response.proposalScheduleGanttPhases[i]
                .proposalScheduleGanttActivities[j].endDate === "string"
                ? new Date(
                    response.proposalScheduleGanttPhases[
                      i
                    ].proposalScheduleGanttActivities[j].endDate
                  )
                : response.proposalScheduleGanttPhases[i]
                    .proposalScheduleGanttActivities[j].endDate;
          }
        }
      }

      this.model = response;

      this.annoucementId = this.model.annoucementId as number;
      this.getAnnoucementDetail();
      this.modelInit = this.map<Porposal>(this.model);
    } catch (errors) {
      this.operationFailedErrors(errors);
    } finally {
      this.loading = false;
    }
  }

  onRemoveDoc(doc: Document) {
    if (this.model.proposalDocuments) {
      this.model.proposalDocuments.map(x => {
        if (doc.id && x.documentId === doc.id) {
          x.deleted = true;
          x.document = null;
        }
        return x;
      });
      if (!doc.id) {
        let index = this.model.proposalDocuments.findIndex(x =>
          this.equals(x.document, doc)
        );
        if (index >= 0) {
          this.model.proposalDocuments.splice(index, 1);
        }
      }
    }
  }
  async send() {
    try {
      var result = await this.$validator.validateAll();
      if (!this.model.projectTypeId) {
        this.$buefy.toast.open({
          message: "El campo tipo de proyecto es obligatorio",
          queue: false,
          duration: 4000,
          type: "is-danger",
          position: "is-top-right"
        });
        this.messageError = "El campo tipo de proyecto es obligatorio";
      }
      this.messageError = "";
      if (result) {
        this.sending = true;
        this.validate(false, true);
      }
      throw this.$validator.errors.items.map(e => e.msg);
    } catch (errors) {
      this.operationFailedErrors(errors);
    }
  }
  get documentsSelected() {
    if (this.model && this.model.proposalDocuments)
      return this.model.proposalDocuments.map(x => x.document);
    return [];
  }

  @Watch("model.executiveSummary")
  public onWordCounterChange() {
    if (this.model.executiveSummary) {
      this.words = this.model.executiveSummary.split(" ");
      this.counter = this.words.length;
    }
  }
  @Watch("counter")
  public onCounterChange() {
    this.counter > 250 ? (this.counter = 250) : "0";
  }
  public wordCounter(event: any) {
    if (this.counter === 250) {
      event.preventDefault();
    }
    if (event.keyCode === 32) {
      if (this.model.executiveSummary) {
        this.words = this.model.executiveSummary.split(" ");
        this.counter = this.words.length;
      }
    } else if (event.keyCode === 8) {
      if (this.model.executiveSummary) {
        this.words = this.model.executiveSummary.split(" ");
        this.counter = this.words.length;
      }
      this.counter === 1 ? (this.counter = 0) : "";
    }
  }

  
  getBrowserInfo() {
    var ua= navigator.userAgent, tem, 
    M= ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if(/trident/i.test(M[1])){
        tem=  /\brv[ :]+(\d+)/g.exec(ua) || [];
        return 'IE '+(tem[1] || '');
    }
    if(M[1]=== 'Chrome'){
        tem= ua.match(/\b(OPR|Edge)\/(\d+)/);
        if(tem!= null) return tem.slice(1).join(' ').replace('OPR', 'Opera');
    }
    M= M[2]? [M[1], M[2]]: [navigator.appName, navigator.appVersion, '-?'];
    if((tem= ua.match(/version\/(\d+)/i))!= null) M.splice(1, 1, tem[1]);
    return M.join(' ');
  };

  parentWidth(elem) {
    return elem.parentElement.clientWidth;
  }

  get isFirefox() {
    let browser = this.getBrowserInfo();
    return browser.includes('Firefox')
  }


  get totalInMounth() {
    let startDate = this.model.startDate as any;
    let endDate = this.model.endDate as any;
    this.model.periodMonth = Math.ceil(
      moment(endDate).diff(startDate, "month", true)
    );
    this.years = [];

    if (startDate & endDate) {
      var years = endDate.getFullYear() - startDate.getFullYear() + 1;
      for (let i = 1; i <= years; i++) {
        this.years.push(i);
      }
    }

    return this.model.periodMonth;
  }
  public getCoins() {
    this.CoinService.getCoins().then(response => {
      if (response) {
        this.Coins = response;
        this.model.coinId = response[0].id;
      }
    });
  }
  @Watch("model.startDate")
  onValidateDate() {
    if (this.model.startDate) {
      if (this.model.endDate) {
        let result = moment(this.model.startDate).isAfter(this.model.endDate);
        if (result) {
          return this.$buefy.toast.open({
            duration: 5000,
            message: "La fecha inicio debe ser menor a la fecha final",
            type: "is-danger"
          });
        }
      }
    }
  }

  @Watch("model.endDate")
  onValidateDatEnd() {
    if (this.model.startDate) {
      if (this.model.endDate) {
        let result = moment(this.model.startDate).isAfter(this.model.endDate);
        if (result) {
          return this.$buefy.toast.open({
            duration: 5000,
            message: "La fecha inicio debe ser menor a la fecha final",
            type: "is-danger"
          });
        }
      }
    }
  }

  @Watch("model.startDate")
  onValidateEmpty() {
    if (this.model.startDate) {
      if (this.model.endDate) {
        let result = moment(this.model.startDate).isAfter(this.model.endDate);
        if (result) {
          return (this.model.startDate = null);
        }
      }
    }
  }
  @Watch("model.endDate")
  onValidateEmptyEnd() {
    if (this.model.startDate) {
      if (this.model.endDate) {
        let result = moment(this.model.startDate).isAfter(this.model.endDate);
        if (result) {
          return (this.model.startDate = null);
        }
      }
    }
  }
  @Watch("model.periodMonth")
  onGrater48() {
    if (this.model.periodMonth)
      if (this.model.periodMonth > 48) {
        return this.$buefy.notification.open({
          duration: 10000,
          message:
            "Segun el articulo 30 del reglamento de Fondocyt la duracion máxima del proyecto es de 48 meses se le sugiere cambiarlo",
          type: "is-danger",
          hasIcon: true
        });
      }
  }

  editorOption = {
    modules: {
      toolbar: [
        ["bold", "italic", "underline"],
        ["blockquote"],
        [{ list: "ordered" }, { list: "bullet" }],
        [{ indent: "-1" }, { indent: "+1" }],
        [{ size: ["small", false, "large", "huge"] }],
        [{ header: [1, 2, 3, 4, 5, 6, false] }],
        [{ font: [] }],
        [{ color: [] }, { background: [] }],
        [{ align: [] }],
        ["clean"],
        ["link", "image", "video"]
      ],
      imageDrop: true
    },
    placeholder: "Escriba el contenido aqui..."
  };

  get user() {
    return this.$store.state.user;
  }
  arrPrueva = [];
  mounted() {
    
    var member = new ProposalMember();
    member.hasUser = true;
    this.getcenterByInvestigatorId();
    member.userId = this.user.id;
    this.model.porposalMembers.push(member);
  }
  created() {
    this.mozillaWidth = `width: 1040px!important`

    this.controller = "Porposal";
    this.getMemberTypes();
    this.getProjectTypes();
    this.getCoins();
    this.getUser();
    this.getBudgetExpenses();
    bus.$on("SendArr", userThatExcedTheCondition => {
      this.arrPrueva = userThatExcedTheCondition;
    });
    console.log(this.arrPrueva + "sdadadas");
  }

  addMember() {
    this.model.porposalMembers.push(new ProposalMember());
  }

  removeMember(row: any) {
    if (row.id) {
      row.deleted = true;
    } else {
      this.model.porposalMembers = this.model.porposalMembers.filter(
        (x: any) => x != row
      );
    }
  }
  removeMemberEffort(row: any) {}
  addMemberEffort(row: any) {
    row.proposalMemberEfforts.push(new PorposalMemberEffort());
  }
  getMemberTypes() {
    this.memberTypeService.getAll().then((list: any) => {
      this.memberTypes = list;
    });
  }
  getProjectTypes() {
    this.projectTypeService.getAll().then((list: any) => {
      this.projectTypes = list;
    });
  }

  public addConsortium() {
    this.model.proposedConsortiums.push(new ProposedConsortium());
  }

  public removeConsortium(row: any) {
    this.model.proposedConsortiums = this.model.proposedConsortiums.filter(
      (x: any) => x != row
    );
  }

  deleteDropFile(index: any) {
    this.dropFiles.splice(index, 1);
  }
  formatDocs() {
    if (this.model.proposalDocuments) {
      this.model.proposalDocuments = this.model.proposalDocuments.map(x => {
        if (x.documentId) delete x.document;
        return x;
      });
    }
  }
  isWatchBudgetReport = false;
  isWatchCashFlowReport = false;

  watchBudgetReport() {
    this.isWatchBudgetReport = true;
    this.validate();
  }

  watchCashFlowReport() {
    this.isWatchCashFlowReport = true;
    this.validate();
  }

  openBudgetReport() {
    var url =
      process.env.VUE_APP_BASE_URL_REPORT +
      "Report/VistaPreviaPresupuesto?proporsalId=" +
      this.model.id;
    window.open(
      url,
      "Reporte de presupuesto",
      "left=20,top=20,width=1000,height=700,toolbar=1,resizable=0"
    );
  }
  openCashFlowReport() {
    var url =
      process.env.VUE_APP_BASE_URL_REPORT +
      "Report/VistaPreviaFlujoCaja?proporsalId=" +
      this.model.id;
    window.open(
      url,
      "Reporte de flujo de caja",
      "left=20,top=20,width=1000,height=700,toolbar=1,resizable=0"
    );
  }
  protected async validate(
    ignoreWarnings: boolean = false,
    isFromEviarPropuesta: any = null,
    showBudgetReport: any = false
  ) {
    try {
      if (this.files.length && this.files.some(x => x.size)) {
        let docs = await fileService.uploadMany(this.files as File[]);
        docs.forEach(doc => {
          doc.refEntityKey = "Id";
          doc.refEntityName = "proposalDocument";
          let proposalDocument = new ProposalDocument();
          proposalDocument.document = doc;
          proposalDocument.contentTypeId = this.contentTypeId;
          if (proposalDocument) {
            this.model.proposalDocuments.push(proposalDocument);
          }
        });
      }
      this.showModal = false;
      this.contentTypeId = null;
      var memberTypesUnic = this.memberTypes.filter(x => x.isUniqueInPorposal);

      for (let i = 0; i < memberTypesUnic.length; i++) {
        const memberType = memberTypesUnic[i];
        var ammount = this.model.porposalMembers.filter(
          x => x.memberTypeId == memberType.id
        ).length;
        if (ammount > 1) {
          this.$buefy.toast.open({
            message:
              "No debe tener más de un miembro de tipo:  " + memberType.name,
            type: "is-danger",
            duration: 2000
          });
          return;
        }
      }

      if (
        !ignoreWarnings &&
        (!this.validate20PercentInstitutionalAport ||
          this.validateBudgetItemIncludeInAnualRuleOfPayOfFondocyt ||
          this.validateBudgetSubItemDistribution ||
          this.validateBudgetItemRuleForPercentageLimitBasedInSubTotal)
      ) {
        this.showWarning = true;
      } else {
        this.showWarning = false;
        await this.edit();
        if (this.isWatchBudgetReport) {
          this.isWatchBudgetReport = false;
          this.openBudgetReport();
        }
        if (this.isWatchCashFlowReport) {
          this.isWatchCashFlowReport = false;
          this.openCashFlowReport();
        }
        if (!isFromEviarPropuesta) {
          this.operationSuccess();
          this.$router.push("/project-by-annoucement");
        }
      }
    } catch (errors) {}
  }

  cleanObj(sendObject: Porposal) {
    sendObject.porposalBudgetItems = sendObject.porposalBudgetItems.map(x => {
      x.budgetItem = null;
      return x;
    });

    sendObject.porposalMembers = sendObject.porposalMembers.map(x => {
      x.user = null;
      return x;
    });

    sendObject.proporsalUsersEvaluators = sendObject.proporsalUsersEvaluators.map(
      x => {
        x.user = null;
        return x;
      }
    );

    sendObject.porposalUsersReports = sendObject.porposalUsersReports.map(x => {
      x.user = null;
      return x;
    });

    sendObject.coin = null;
    sendObject.researchCenter = null;
    sendObject.area = null;
    sendObject.fieldArea = null;
    sendObject.researchLine = null;
  }
  protected async edit() {
    try {
      this.saving = true;
      this.formatDocs();
      this.model.proposedConsortiums.filter(x => {
        x.originalName = x.name;
      });
      this.changeConsortiums();
      var sendObject = Utils.mapToObject(
        this.model,
        new Porposal()
      ) as Porposal;

      this.cleanObj(sendObject);

       // presupuesto
      sendObject.totalBudgetHistory = this.totalBudget;
      sendObject.fondocytContribution = this.totalBudgetFondocyt;
      sendObject.totalCounterPart =
        this.totalBudgetInstitutionalAport +
        (this.totalBudget -
          this.totalBudgetFondocyt -
          this.totalBudgetInstitutionalAport);
      // end presupuesto

      var result = await this.repository
        .update(this.id, sendObject)
        .finally(() => {
          this.getData();
        });
      this.model.code = result.code;
      this.saving = false;
      this.$emit("edit", result);
      if (this.sending) {
        this.$router.push(`/convocatoria/propuesta/${result.id}/confirmation`);
      }
    } catch (error) {
      var errors: any[] = [];
      if (Object.prototype.toString.call(error.data) === "[object String]") {
        errors.push(error.data);
      } else if (error.data && error.data.length > 0) {
        var errorMessages = error.data as any[];
        errorMessages.forEach(x => errors.push(x.errorMessage));
      } else {
        errors.push(error);
      }
      console.log(errors);
      this.operationFailedErrors(errors);

      this.sending = false;
      this.model.enviada = false;
      this.model.sendDateToIES = null;
    } finally {
      this.saving = false;
    }
  }

  getBudgetExpenses() {
    this.budgetExpenseService.getBudgetExpenses().then(response => {
      if (response) {
        this.budgetExpenses = response;
      }
    });
  }

  showBudgetItem(budgetExpenseId: number) {
    this.showAddPartida = true;
    this.budgetItemCurrent.budgetExpenseId = budgetExpenseId;
  }
  addPartida() {
    if (this.budgetItemCurrent.budgetItem.id) {
      var newPartida = Utils.mapToObject(
        this.budgetItemCurrent,
        new PorposalBudgetItem()
      ) as PorposalBudgetItem;
      this.model.porposalBudgetItems.push(newPartida);
      this.budgetItemCurrent.init();
      this.showAddPartida = false;
    } else {
      this.operationFailed("Debe seleccionar una partida");
    }
  }
  deletePartida(item: PorposalBudgetItem) {
    if (item.id) {
      item.deleted = true;
    } else {
      this.model.porposalBudgetItems = this.model.porposalBudgetItems.filter(
        budgetItem => budgetItem != item
      );
    }
  }

  onBugetItem(item: BudgetItem) {
    this.budgetItemCurrent.budgetItem = item;
  }
  onRemoveBugetItem() {
    this.budgetItemCurrent.budgetItem = new BudgetItem();
  }

  calculateProposalBudgetSubItemByInstitution(
    porposalBudgetSubItem: PorposalBudgetSubItem
  ) {
    if (porposalBudgetSubItem.currentInstitution == 0) {
      var filteredDetails = porposalBudgetSubItem.porposalBudgetSubItemInstitutionDetails.filter(
        x => x.isFondocyt && !x.deleted
      );
      return filteredDetails.reduce((a: any, b: any) => {
        var amount = b.amount ? parseFloat(b.amount as any) : 0;
        return a + amount;
      }, 0);
    } else {
      var filteredDetails = porposalBudgetSubItem.porposalBudgetSubItemInstitutionDetails.filter(
        x =>
          (x.researchCenterId == porposalBudgetSubItem.currentInstitution ||
            x.institutionName == porposalBudgetSubItem.currentInstitution) &&
          !x.deleted
      );
      return filteredDetails.reduce((a: any, b: any) => {
        var amount = b.amount ? parseFloat(b.amount as any) : 0;
        return a + amount;
      }, 0);
    }
  }

  calculateProposalBudgetSubItem(porposalBudgetSubItem: PorposalBudgetSubItem) {
    return porposalBudgetSubItem.porposalBudgetSubItemInstitutionDetails
      .filter(x => !x.deleted)
      .reduce((a: any, b: any) => {
        var amount = b.amount ? parseFloat(b.amount as any) : 0;
        return a + amount;
      }, 0);
  }
  calculateProposalBudgetItemByYear(porposalBudgetItem: PorposalBudgetItem) {
    var budgets = porposalBudgetItem.porposalBudgetItemInstitutions
      .filter(x => !x.deleted)
      .filter((x: any) => x.yearNumber == porposalBudgetItem.currentYear);
    return budgets.reduce((a: any, b: any) => {
      var amount = b.amount ? parseFloat(b.amount as any) : 0;
      return a + amount;
    }, 0);
  }

  get canConfigureBudget() {
    return (
      this.model.startDate &&
      this.model.endDate &&
      this.model.coinId &&
      this.model.researchCenterId
    );
  }

  showModalBudgetSubItem(porposalBudgetItem: PorposalBudgetItem) {
    this.showAddSubPartida = true;
    this.budgetSubItemCurrent.porposalBudgetItem = porposalBudgetItem;
    this.budgetSubItemCurrent.budgetItemId = porposalBudgetItem.budgetItemId;
  }
  addBudgetSubItem() {
    if (this.budgetSubItemCurrent.budgetSubItem) {
      var porposalBudgetSubItem = Utils.mapToObject(
        this.budgetSubItemCurrent,
        new PorposalBudgetSubItem()
      ) as PorposalBudgetSubItem;

      var defaultPeriod = YearPeriod.ThreeMonth;
      var quantityMonth = 12;
      var quantityPeriodInYear = quantityMonth / defaultPeriod;

      for (let y = 0; y < this.years.length; y++) {
        const year = this.years[y];

        var startPeriod = 1;
        var endPeriod = quantityPeriodInYear;
        if (y == 0) {
          if (this.model.startDate) {
            var startPeriod = Math.ceil(
              (this.model.startDate.getMonth() + 1) / defaultPeriod
            );
          }
        } else if (y == this.years.length - 1) {
          if (this.model.endDate) {
            endPeriod = Math.ceil(
              (this.model.endDate.getMonth() + 1) / defaultPeriod
            );
          }
        }

        for (let i = startPeriod; i <= endPeriod; i++) {
          let detail = new PorposalBudgetSubItemInstitutionDetail();
          detail.yearNumber = year;
          detail.periodNumber = i;
          detail.isFondocyt = true;
          porposalBudgetSubItem.porposalBudgetSubItemInstitutionDetails.push(
            detail
          );
        }
        let detail2 = new PorposalBudgetSubItemInstitutionDetail();
        detail2.yearNumber = year;
        detail2.researchCenterId = this.model.researchCenterId;
        porposalBudgetSubItem.porposalBudgetSubItemInstitutionDetails.push(
          detail2
        );
      }

      this.budgetSubItemCurrent.porposalBudgetItem.porposalBudgetSubItems.push(
        porposalBudgetSubItem
      );

      this.budgetSubItemCurrent.init();
      this.showAddSubPartida = false;
    } else {
      this.operationFailed("Debe escribir la sub-partida");
    }
  }

  onCancelSubPartida() {
    this.showAddSubPartida = false;
  }

  removePorposalBudgetSubItem(
    porposalBudgetSubItem: PorposalBudgetSubItem,
    porposalBudgetItem: PorposalBudgetItem
  ) {
    if (porposalBudgetSubItem.id) {
      porposalBudgetSubItem.deleted = true;
    } else {
      porposalBudgetItem.porposalBudgetSubItems = porposalBudgetItem.porposalBudgetSubItems.filter(
        (x: any) => x != porposalBudgetSubItem
      );
    }
  }

  get validate20PercentInstitutionalAport() {
    if (!this.model.porposalBudgetItems.filter(x => !x.deleted).length) {
      return true;
    }
    return this.totalBudgetInstitutionalAport >= (this.totalBudget * 20) / 100;
  }
  get validateBudgetSubItemDistribution() {
    if (!this.model.porposalBudgetItems.filter(x => !x.deleted).length) {
      return "";
    }
    var budgetItemFiltered = this.model.porposalBudgetItems.filter(
      x => !x.deleted
    );
    for (let i = 0; i < budgetItemFiltered.length; i++) {
      const item = budgetItemFiltered[i];
      var subItemFiltered = item.porposalBudgetSubItems.filter(x => !x.deleted);
      for (let y = 0; y < subItemFiltered.length; y++) {
        const subitem = subItemFiltered[y];
        var amountDistribute = this.calculateProposalBudgetSubItem(
          subitem
        ).toFixed(2);
        var totalAmount = subitem.unitCost * subitem.month;

        var withoutDistribution = totalAmount - amountDistribute;

        if (withoutDistribution > 0) {
          return `En la sub-partida presupuestaria <b>${
            subitem.budgetSubItem
          }</b> la  cual forma parte de la partida <b>${
            item.budgetItem.name
          }</b>  faltan por distribuir entre instituciones el monto de  <b>${
            this.model.coin.currency
          } ${this.$options.filters.currency(withoutDistribution)}</b>.`;
        } else if (withoutDistribution < 0) {
          return `En la sub-partida presupuestaria <b>${
            subitem.budgetSubItem
          }</b> la  cual forma parte de la partida <b>${
            item.budgetItem.name
          }</b>  se ha distribuido entre instituciones un monto de extra de  <b>${
            this.model.coin.currency
          } ${this.$options.filters.currency(withoutDistribution * -1)}</b>.`;
        }
      }
    }
  }

  get validateBudgetItemIncludeInAnualRuleOfPayOfFondocyt() {
    if (!this.model.porposalBudgetItems.filter(x => !x.deleted).length) {
      return "";
    }
    for (let z = 0; z < this.years.length; z++) {
      const year = this.years[z];
      var amountYearTopFondocyt = 0;
      var amountYear = 0;
      var porposalBudgetItems = this.model.porposalBudgetItems.filter(x =>
        x.budgetItem ? x.budgetItem.hasIncludeInAnualRuleOfPayOfFondocyt : false
      );
      var porposalBudgetItemsFiltered = porposalBudgetItems.filter(
        x => !x.deleted
      );
      for (let i = 0; i < porposalBudgetItemsFiltered.length; i++) {
        const budgetItem = porposalBudgetItemsFiltered[i];

        var porposalBudgetSubItemsFiltered = budgetItem.porposalBudgetSubItems.filter(x=> !x.deleted);

        for (let j = 0; j < porposalBudgetSubItemsFiltered.length; j++) {
          const subItem = porposalBudgetSubItemsFiltered[j];
          var subBudgetInstitutions = subItem.porposalBudgetSubItemInstitutionDetails.filter(
            (x: PorposalBudgetSubItemInstitutionDetail) =>
              x.yearNumber == year && !x.deleted
          );

          for (let y = 0; y < subBudgetInstitutions.length; y++) {
            const subBudgetInstitution = subBudgetInstitutions[y];
            var amount = subBudgetInstitution.amount as any;
            if (subBudgetInstitution.isFondocyt) {
              amountYearTopFondocyt += amount;
            }
            amountYear += amount;
          }
        }
      }
      if (amountYearTopFondocyt > (amountYear * 10) / 100) {
        var porcentaje = ((amountYearTopFondocyt * 100) / amountYear).toFixed(
          2
        );
        return `En el año <b>${year}</b> la suma de las partidas marcadas como <b>\"Incluidas para reglas\" </b> es mayor al 10% del tope anual de FONDOCYT. Actualmente FONDOCYT en su prespuesto esta cubriendo un  <b>${porcentaje}% </b> del año  <b>${year} </b>.`;
      }
    }
    return "";
  }
  getUser() {
    this.loading = true;
    this.userService
      .getUserById(this.user.id)
      .then(user => {
        this.currentuserObj = user;
      })
      .finally(() => {
        this.loading = false;
      });
  }

  get validateBudgetItemRuleForPercentageLimitBasedInSubTotal() {
    if (!this.model.porposalBudgetItems.filter(x => !x.deleted).length) {
      return "";
    }

    var subTotal = 0;
    var porposalBudgetItems = this.model.porposalBudgetItems.filter(
      x =>
        (x.budgetItem
          ? !x.budgetItem.hasRuleForPercentageLimitBasedInSubTotal
          : false) && !x.deleted
    );

    for (let i = 0; i < porposalBudgetItems.length; i++) {
      const budgetItem = porposalBudgetItems[i];
      var subItemsFiltered = budgetItem.porposalBudgetSubItems.filter(
        x => !x.deleted
      );
      for (let j = 0; j < subItemsFiltered.length; j++) {
        const subItem = subItemsFiltered[j];
        var subBudgetInstitutions = subItem.porposalBudgetSubItemInstitutionDetails.filter(
          x => !x.deleted
        );
        for (let y = 0; y < subBudgetInstitutions.length; y++) {
          const subBudgetInstitution = subBudgetInstitutions[y];
          var amount = subBudgetInstitution.amount as any;
          subTotal += amount;
        }
      }
    }

    var porposalBudgetItemsRuleForPercentage = this.model.porposalBudgetItems.filter(
      x =>
        (x.budgetItem
          ? x.budgetItem.hasRuleForPercentageLimitBasedInSubTotal
          : false) && !x.deleted
    );

    for (let i = 0; i < porposalBudgetItemsRuleForPercentage.length; i++) {
      var total = 0;

      const budgetItem = porposalBudgetItemsRuleForPercentage[i];
      var subItemsFiltered = budgetItem.porposalBudgetSubItems.filter(
        x => !x.deleted
      );
      for (let j = 0; j < subItemsFiltered.length; j++) {
        const subItem = subItemsFiltered[j];
        var subBudgetInstitutions = subItem.porposalBudgetSubItemInstitutionDetails.filter(
          x => !x.deleted
        );
        for (let y = 0; y < subBudgetInstitutions.length; y++) {
          const subBudgetInstitution = subBudgetInstitutions[y];
          var amount = subBudgetInstitution.amount as any;
          total += amount;
        }
      }
      if (
        total >
        (subTotal * budgetItem.budgetItem.percentageLimitBasedInSubTotal) / 100
      ) {
        var porcentaje = ((total * 100) / subTotal).toFixed(2);

        return `La partida presupuestaria <b>${budgetItem.budgetItem.name}</b> sobrepasa su limite de <b>${budgetItem.budgetItem.percentageLimitBasedInSubTotal}%</b> basado en el subtotal actualmente tiene un porcentaje de <b>${porcentaje}%</b>.`;
      }
    }

    return "";
  }
  get institutionBudgetByYear() {
    var institutionBudgetByYear = [];
    if (!this.model.porposalBudgetItems.filter(x => !x.deleted).length) {
      return true;
    }
    this.totalBudgetFondocyt = 0;
    this.totalBudgetInstitutionalAport = 0;
    this.totalBudget = 0;
    for (let z = 0; z < this.years.length; z++) {
      const year = this.years[z];
      var resume = {
        year: 0,
        FONDOCYT: 0,
        institutionalAport: 0,
        othersInstitutions: 0
      };
      var porposalBudgetItemsFiltered = this.model.porposalBudgetItems.filter(
        x => !x.deleted
      );
      for (let i = 0; i < porposalBudgetItemsFiltered.length; i++) {
        const budgetItem = porposalBudgetItemsFiltered[i];
        var porposalBudgetSubItemsFiltered = budgetItem.porposalBudgetSubItems.filter(x => !x.deleted);

        for (let j = 0; j < porposalBudgetSubItemsFiltered.length; j++) {
          const subItem = porposalBudgetSubItemsFiltered[j];
          var subBudgetInstitutions = subItem.porposalBudgetSubItemInstitutionDetails.filter(
            (x: PorposalBudgetSubItemInstitutionDetail) =>
              x.yearNumber == year && !x.deleted
          );
          resume.year = year;

          for (let y = 0; y < subBudgetInstitutions.length; y++) {
            const subBudgetInstitution = subBudgetInstitutions[y];
            var amount = subBudgetInstitution.amount as any;
            if (subBudgetInstitution.isFondocyt) {
              resume.FONDOCYT += amount;
            } else if (subBudgetInstitution.researchCenterId) {
              resume.institutionalAport += amount;
            } else {
              resume.othersInstitutions += amount;
            }
          }
        }
      }
      institutionBudgetByYear.push(resume);
      this.totalBudgetFondocyt += resume.FONDOCYT;
      this.totalBudgetInstitutionalAport += resume.institutionalAport;
      this.totalBudget +=
        resume.FONDOCYT + resume.institutionalAport + resume.othersInstitutions;
    }
    return institutionBudgetByYear;
  }

  get withoutCode() {
    return this.model.porposalMembers
      .filter(x => !x.deleted)
      .filter(x => x.user)
      .map(x => x.user)
      .filter(x => !x.careerCode || x.careerCode == "0");
  }

  @Watch("currentTab")
  onCurrentTab() {
    if (this.currentTab == 1) {
      this.model.proposedConsortiums.filter(x => {
        x.originalName = x.name;
      });
    }
  }

  onClickTabBudget() {
    this.currentTab = 7;
    if (this.model.modality == PorposalModality.PROPUESTACONSORCIONADA) {
      this.changeConsortiums();
    }
  }

  changeConsortiums() {
    this.model.proposedConsortiums.filter((consortium: ProposedConsortium) => {
      this.model.porposalBudgetItems.filter((item: PorposalBudgetItem) => {
        item.porposalBudgetSubItems.filter((subItem: PorposalBudgetSubItem) => {
          subItem.currentInstitution = 0;
          var any = subItem.porposalBudgetSubItemInstitutionDetails
            .filter(x => {
              if (
                x.institutionName &&
                x.institutionName == consortium.originalName
              )
                x.institutionName = consortium.name;

              return !x.isFondocyt && !x.researchCenterId;
            })
            .some((detail: PorposalBudgetSubItemInstitutionDetail) => {
              return detail.institutionName == consortium.name;
            });

          if (!any) {
            for (let y = 0; y < this.years.length; y++) {
              const year = this.years[y];
              let detail = new PorposalBudgetSubItemInstitutionDetail();
              detail.yearNumber = year;
              detail.institutionName = consortium.name;
              detail.researchCenterId = null;
              subItem.porposalBudgetSubItemInstitutionDetails.push(detail);
            }
          }
        });
      });
    });
    this.model.porposalBudgetItems.filter((item: PorposalBudgetItem) => {
      item.porposalBudgetSubItems.filter((subItem: PorposalBudgetSubItem) => {
        subItem.porposalBudgetSubItemInstitutionDetails = subItem.porposalBudgetSubItemInstitutionDetails.filter(
          x => {
            if (x.isFondocyt || x.researchCenterId) {
              return true;
            } else if (
              this.model.proposedConsortiums.some(
                y => y.name == x.institutionName
              )
            ) {
              var proposedConsortium = this.model.proposedConsortiums.filter(
                y => y.name == x.institutionName
              );
              if (proposedConsortium[0].deleted) x.deleted = true;

              return true;
            }
            return false;
          }
        );
      });
    });
  }

  @Watch("model.fondocytContribution")
  @Watch("model.totalCounterPart")
  onTotalBudgetChange() {
    this.model.totalBudgetHistory = Number(
      this.model.fondocytContribution + this.model.totalCounterPart
    );
  }

  @Watch("model.fondocytContribution")
  @Watch("model.totalDisbursedToDate")
  onPendingDirsbursmentChange() {
    this.model.pendingDisbursement = Number(
      this.model.fondocytContribution - this.model.totalDisbursedToDate
    );
  }
}
